<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<v-row>
			<v-col cols="12" md="6">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line
					hide-details class="mb-5" />
			</v-col>
			<v-col cols="12">
				<v-data-table dense :headers="headers" :loading="loading" :items="agents"
					:footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search"
					class="elevation-1">
					<template v-slot:item.firstName="{ item }">
						<div><a href="javascript:void(0)" @click="edit(item)" class="info--text">{{ item.firstName }}</a></div>
						<div><small>نام تجاری: </small><small class="grey--text">{{ item.businessName }}</small></div>
						<div class="d-flex"><small>شماره تماس: </small><small class="grey--text pr-1">{{ item.mobile }}<br />{{
							item.phone
						}}</small>
						</div>
					</template>
					<template v-slot:item.agent="{ item }">
						<div>{{ item.parentAgentBusinessName }}</div>
						<div class="grey--text"><small>{{ item.parentAgentName }}</small></div>
					</template>
					<template v-slot:item.loanRequestCount="{ item }">
						<div @click="loanRequestsList(item)" class="" style="cursor: pointer;font-size: 12px;">
							<div v-for="c in item.dynamicLoanRequstCounts" :key="c.title">{{ c.title }}: <span class="info--text">{{
								c.count }}</span></div>
						</div>
					</template>
					<template v-slot:item.loanCount="{ item }">
						<div @click="loansList(item)" class="info--text" style="cursor: pointer;">تعداد: {{ item.loanCount }}</div>
						<div class="grey--text">مجموع: {{ item.totalLoans.toString().toPriceFormat() }}</div>
						<!-- <div v-if="item.loanCount!==0"><small><a href="javascript:void(0)" @click="loansList(item)" class="info--text text-small">مشاهده</a></small></div> -->
					</template>
					<template v-slot:item.totalAgentShare="{ item }">
						{{ item.totalAgentShare.toString().toPriceFormat() }}
					</template>
					<template v-slot:item.totalReceives="{ item }">
						<div @click="transactionList(item)" class="info--text" style="cursor: pointer;">{{
							item.totalReceives.toString().toPriceFormat() }}</div>
						<!-- <div v-if="item.totalReceives!==0"><small><a href="javascript:void(0)" @click="transactionList(item)" class="info--text text-small">مشاهده</a></small></div> -->
					</template>
					<template v-slot:item.phone="{ item }">
						{{ (item.totalAgentShare - item.totalReceives).toString().toPriceFormat() }}
					</template>
					<template v-slot:item.lastLoginDate_Persian="{ item }">
						<div class="ltr">
							{{ `${item.lastLoginDate_Persian.date} ${item.lastLoginDate_Persian.time}` }}
						</div>
					</template>
					<template v-slot:item.isActive="{ item }">
						<v-icon v-if="item.isActive" color="success" title="غیرفعال">
							mdi-check-circle
						</v-icon>
						<v-icon v-else color="error" title="فعال">
							mdi-close-circle
						</v-icon>
					</template>
					<template v-slot:item.operations="{ item }">
						<div class="text-center">
							<v-btn class="mx-1" fab dark small color="secondary" @click="edit(item)">
								<v-icon dark>
									mdi-square-edit-outline
								</v-icon>
							</v-btn>
							<v-btn class="mx-1" fab dark small color="pink" @click="remove(item)">
								<v-icon dark>
									mdi-trash-can-outline
								</v-icon>
							</v-btn>
						</div>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogAgent" scrollable persistent max-width="1100px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات نماینده</span>
					<v-spacer />
					<v-btn @click="dialogAgent = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifyAgent :data="selectedAgent" v-if="dialogAgent" @callbck="callbck" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogLoanRequestsList" scrollable max-width="1400px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست درخواست وام های {{ selectedAgent.businessName }}</span></div>
					<v-spacer />
					<v-btn @click="dialogLoanRequestsList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<AgentRequests v-if="dialogLoanRequestsList" :data="{ member: selectedAgent }" :agent="selectedAgent"
						@update="loadData" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogLoansList" scrollable max-width="1400px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست پرونده های وام {{ selectedAgent.businessName }}</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<UserLoans v-if="dialogLoansList" :data="{ member: selectedAgent }" :agent="selectedAgent" @update="loadData" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSubAgentTransactionsList" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline"> لیست واریزی ها به {{ selectedAgent.businessName }}</span></div>
					<v-spacer />
					<v-btn @click="dialogSubAgentTransactionsList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<SubAgentTransactions v-if="dialogSubAgentTransactionsList" :agent="selectedAgent" @update="loadData" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'SubAgentsView',
		props: {
			parentAgentId: { type: Number },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ModifyAgent: () => import('@/views/admin/agent/ModifyAgent'),
			UserLoans: () => import('../AgentUserLoans.vue'),
			AgentRequests: () => import('../AgentRequests.vue'),
			AgentTransactions: () => import('../AgentTransactions.vue'),
			SubAgentTransactions: () => import('@/views/agent/sub-agent/SubAgentTransactions.vue'),
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				errorMessages: '',
				datePickerValidatioin: '',
				localData: {},
				selectedAgent: {},
				dialogAgent: false,
				dialogLoanRequestsList: false,
				dialogLoansList: false,
				dialogSubAgentTransactionsList: false,
				search: '',
				loading: false,
				headers: [
					{
						text: 'نام نماینده',
						align: 'start',
						sortable: true,
						value: 'firstName',
						width: 200
					}, {
						text: 'نام تجاری',
						align: 'center d-none',
						sortable: true,
						value: 'businessName',
						width: 175
					}, {
						text: 'شماره تماس',
						align: 'center d-none',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'تماس ثابت',
						align: 'center d-none',
						sortable: true,
						value: 'phone',
					}, {
						text: 'نماینده سطح بالاتر',
						align: 'start',
						sortable: true,
						value: 'agent',
						width: 175
					}, {
						text: 'درخواست وام ها',
						align: 'center',
						sortable: true,
						value: 'loanRequestCount',
						width: 150
					}, {
						text: 'پرونده های وام',
						align: 'center',
						sortable: true,
						value: 'loanCount',
						width: 200
					}, {
						text: 'سهم نماینده',
						align: 'center',
						sortable: true,
						value: 'totalAgentShare',
					}, {
						text: 'تسویه شده',
						align: 'center',
						sortable: true,
						value: 'totalReceives',
					}, {
						text: 'مانده تسویه نشده',
						align: 'center',
						sortable: true,
						value: 'phone',
					}, {
						text: 'آخرین ورود',
						align: 'center',
						sortable: true,
						value: 'lastLoginDate_Persian',
					}, {
						text: 'اکانت فعال',
						align: 'center',
						sortable: true,
						value: 'isActive',
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						value: 'operations',
						width: 135,
					},
				],
				agents: [],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/agent/SubAgentList' + `${this.parentAgentId ? '?parentId=' + this.parentAgentId : ''}`, null)
					.then(
						response => {
							this.agents = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			add() {
				this.selectedAgent = { id: 0 }
				this.dialogAgent = true
			},
			edit(item) {
				this.selectedAgent = item
				this.dialogAgent = true
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/agent/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			callbck(result) {
				this.dialogAgent = false
				if (result)
					this.loadData(true)
			},
			loanRequestsList(item) {
				this.selectedAgent = item
				this.dialogLoanRequestsList = true
			},
			loansList(item) {
				this.selectedAgent = item
				this.dialogLoansList = true
			},
			transactionList(item) {
				this.selectedAgent = item
				this.dialogSubAgentTransactionsList = true
			}

		},
	}
</script>
<style></style>
